<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex align-items-center mb-2" style="gap:10px;">
        <div class="section-title ">{{ $t("Maccs Log") }}</div>

        <div class="px-2  w-25">
          <input
            required
            autofocus
            type="search"
            :placeholder="$t('Search File')"
            class="form-control form-control-sm"
            v-on:input="onSearchFile($event.target.value)"
            v-on:search="onSearchFile($event.target.value)"
            v-model="searchCinema"
          />
        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table mb-3" border="1">
          <thead>
            <tr>
              <th>{{ $tc("Rec") }}</th>
              <th>{{ $tc("Created") }} {{ $tc("At") }}</th>
              <th>{{ $tc("Type") }}</th>
              <th>{{ $tc("View") }} {{ $tc("File") }}</th>
              <th>{{ $tc("MACCS") }} {{ $tc("File") }}</th>
              <th>{{ $tc("File Zilla Response") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(macsValue, macsIndex) in macsData"
              :key="macsIndex"
              :style="!macsValue.filezilla_response_status ? 'color:red' : ''"
              class="light_grey_back"
            >
              <td style="text-align:right" class="padd">{{ macsIndex + 1 }}</td>
              <td style="text-align:right" class="padd">
                {{ macsValue.created_at }}
              </td>
              <td class="padd">{{ macsValue.type }}</td>
              <td class="font-blue padd">
                <div
                  class="d-flex align-items-center justify-content-center"
                  style="cursor:pointer;"
                >
                  <div class="">
                    <img
                      src="@/assets/img/icons/view.png"
                      alt="View File"
                      @click="showFile(macsValue)"
                    />
                  </div>
                </div>
              </td>
              <td class="padd">
                {{ macsValue.file_name }}
              </td>
              <td class="padd">{{ macsValue.filezilla_response }}</td>
              <!-- <td>{{ macsValue.file_name }}</td>
              <td>{{ macsValue.filezilla_response }}</td> -->
              <!-- <td class="icon-eye blue-icon btn" @click="openWindow($event)">
                {{ macsValue.maccs_upload_path }}
              </td> -->
            </tr>
          </tbody>
          <tbody v-if="macsData.length == 0">
            <tr>
              <td colspan="13">
                <!-- <p v-if="reservationList.length == 0" class="text-center">
                  {{ $tc("NoRecords") }}
                </p> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-pagination
        v-if="reservationList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
        class="my-3"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import UserService from "@/services/UserService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import scheduleService from "@/services/scheduleService";
import PosService from "@/services/PosService";
import Printd from "printd";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { createQueryString } from "@/services/ApiHelper";

export default {
  components: { DatePicker, Multiselect, NoRecords },
  data() {
    return {
      macsData: [],
      tempData: [],
      macsSearch: "",

      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      selectedFilterValue: "",
      filterValues: [],
      filterValuesCopy: [],
      searchFilterValues: "",
      isRoleID: true,
      reservationList: [],
      reservationListCopy: [],
      searchUserValue: "",
      searchUsers: [],
      isSearchLoading: false,
      schedules: [],
      selected_ssid: "",
      selected_show_time: null,

      selectedFilter: "",
      users: ["Screen", "Movie", "User", "Show Booking Code"],
      fetchReservationDetail: {
        date: "",
        cinema_id: null,
        ssb_code: "",
        show_date: "",
        show_date_to: null,
        from_date: "",
        to_date: null
      },
      filterkey: "",
      filtervalue: "",
      selectedCinema: "",
      Cinemas: [],
      EjsData: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      sendMailObj: [],
      currencyData: "",

      searchReservations: ""
    };
  },
  beforeMount() {
    this.getMacsLog();
  },
  methods: {
    showFile(obj) {
      window.open(obj.maccs_upload_path);
    },
    // onSearchReservation() {
    //   this.currentPage = 1;
    //   this.onGetTransactionList();
    // },
    getMacsLog: function() {
      MasterService.GetMacsLog().then(response => {
        const { data } = response;
        console.log(response);
        if (data && data.status && data.Records.length > 0) {
          this.macsData = data.Records;
          this.tempData = data.Records;
          console.log("this.macsData", this.macsData);
        } else {
          console.log("data.message :", data.message);
        }
      });
    },
    onSearchFile: function(value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        let search_value = this.searchCinema.toLowerCase();
        let check_array = [
          "file_name",
          "created_at",
          "type",
          "filezilla_response"
        ];
        this.macsData = this.tempData.filter(x => {
          let obj = {};
          let check = false;
          check_array.map(y => {
            if (typeof x[y] == "object") {
              obj[y] = JSON.stringify(x[y])
                .toLowerCase()
                .includes(search_value);
            } else {
              obj[y] = x[y].toLowerCase().includes(search_value);
            }
            if (!check && obj[y]) {
              check = true;
            }
          });
          return check;
        });
      } else {
        this.macsData = this.tempData;
      }
    }
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
.icon-size {
  padding-top: 14px;
  padding-bottom: 14px;
  margin: auto;
}
td {
  text-align: left;
  padding: 0px;
}
.padd {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/Macs/macsLog.vue